import produce from 'immer';
import {
  FAILURE,
  fulfilled,
  idle,
  pending,
  rejected,
  REQUEST,
  SUCCESS,
} from 'src/redux/constants';
import { ONE_MODELS } from './constants';
import {
  OneModelsSuccess,
  OneModelsError,
  OneModelsDataActionTypes,
  OneModelsState,
} from './types';

const initialState: OneModelsState = {
  status: idle,
  entities: null,
  error: null,
};

export default produce(
  (draft = initialState, action: OneModelsDataActionTypes): OneModelsState => {
    switch (action.type) {
      case ONE_MODELS + REQUEST: {
        draft.status = pending;
        draft.error = null;
        break;
      }
      case ONE_MODELS + SUCCESS: {
        draft.status = fulfilled;
        draft.entities = (action as OneModelsSuccess).payload;
        break;
      }
      case ONE_MODELS + FAILURE: {
        draft.status = rejected;
        draft.error = (action as OneModelsError).error;
        break;
      }
      default:
        return draft;
    }
  },
);
